import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "009_add_default_ai_agent",
  version: "0.9.0",
  sql: `
ALTER TABLE \`connectors_instances\` ADD COLUMN \`default_ai_agent_id\` text;
`,
};
